









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DeleteMemberAddressConfig, QueryMemberAddressConfigList,QueryMemberAllList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import EditMemberAddressConfigDialog from './EditMemberAddressConfigDialog.vue'
import { MemberAddressConfigLevelFormat} from '@/utils/tyepconvert'
import constant from '@/utils/constant'


@Component({
  components: {
    VQuery,
    VTable,
    EditMemberAddressConfigDialog,
  },
})
export default class VideoList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private levelQueryParam:QueryModel =  { title: '级别', param: 'level', type:"select",selectData: [] }
  private queryModels: Array<QueryModel> = [
    this.levelQueryParam,
    { title: '省名称', param: 'provinceName' },
    { title: '市名称', param: 'cityName' },
    { title: '区名称', param: 'districtName' },
    { title: '用户手机', param: 'mobilePhone' },
    { title: '用户名称', param: 'nickname' },
    { title: '用户编号', param: 'userId' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '创建区域代理', type: 'primary', click: this.openCreateVideo }]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '用户编号', param: 'userId' },
    { title: '用户名称', param: 'nickname' },
    { title: '用户手机', param: 'mobilePhone' },
    { title: '级别', param: 'level' , formatter: MemberAddressConfigLevelFormat},
    { title: '省名称', param: 'provinceName' },
    { title: '市名称', param: 'cityName' },
    { title: '区名称', param: 'districtName' },
    { title: '创建时间', param: 'createTime',formatter: DateFormat,width:160 },

    {
      title: '操作',
      operation: [
        { title: '编辑', click: this.openEditVideo },
        { title: '删除', click: this.delete },
      ],
    },
  ]

  public async created() {
    this.loadData()
    this.levelQueryParam.selectData = constant.MemberAddressConfigLevel;
  }



  private openCreateVideo() {
    const d = this.$refs.EditMemberAddressConfigDialog as EditMemberAddressConfigDialog
    d.open({}, false)
  }

  private delete(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteMemberAddressConfig({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }

  public openEditVideo(data: any) {
    const d = this.$refs.EditMemberAddressConfigDialog as EditMemberAddressConfigDialog
    d.open(data, true)
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryMemberAddressConfigList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
